import { Outlet } from 'react-router-dom'
import React from 'react'

const Premium = () => {
  return (
    <Outlet/>
  )
}

export default Premium